import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SciSistema } from '~models/maestros-sync/SciSistema';
import { ApiResponse } from '~shared/interface/ApiResponse';
import { INgSelectObject } from '~shared/interface/INgSelectObject';

@Injectable({
	providedIn: 'root',
})
export class SciSistemasService {
	private readonly _url = `${environment.HOST_MAESTROS_SYNC}/scisistemas`;
	//private readonly _COD_SISTEMA = environment.COD_SISTEMA;

	constructor(protected readonly _http: HttpClient) {}

	findByCodigo(codigo: string): Observable<SciSistema> {
		return this._http
			.get<ApiResponse<SciSistema>>(`${this._url}/findByCodigo/${codigo}`)
			.pipe(map((res) => res.data));
	}
	findAllByEstadoNgSelect(estado: boolean): Observable<INgSelectObject<SciSistema>[]> {
		return this._http
			.get<ApiResponse<SciSistema[]>>(`${this._url}/findAllByEstadoNgSelect/${estado}`)
			.pipe(map((res) => res.data.map((d) => this.convertToNgSelect(d))));
	}
	convertToNgSelect(res: SciSistema): INgSelectObject<SciSistema> {
		return {
			...res,
			value: res.idSistema,
			label: `${res.codigo} - ${res.nombre}`,
		};
	}
}
